// const mySwiper = new Swiper('.mySwiper', {

//     loop: true,
//     speed: 4000, 
//     slidesPerView: 1.2,
//       spaceBetween: 5,
//     autoplay: {
//         delay: 0,
//         disableOnInteraction: false,
//     },
//     allowTouchMove: false,
//      breakpoints: {
//         640: {
//           slidesPerView: 2,
//           spaceBetween: 10,
//         },
//         768: {
//           slidesPerView: 4,
//           spaceBetween: 10,
//         },
//         1024: {
//           slidesPerView: 4,
//           spaceBetween: 10,
//         },
// }
// });

var splide = new Splide('#giveaway-slides', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  perPage: 4,
  pagination: false,
  arrows: false,
  autoScroll: {
    autoStart: true,
    speed: 1.75,
    pauseOnHover: true,
  },
  breakpoints: { 
    767: {
        perPage: 1,
        gap: 5,
        padding: '10%',
        pauseOnHover: false,
        autoScroll: {
            speed: 2,
        }
    }, 
   }
});

splide.mount(window.splide.Extensions);

if (window.innerWidth <= 767) {
  splide.on('click', function (Slide) {
    // Move to the clicked slide index and center it
    splide.go(Slide.index);
  });
}

var splide2 = new Splide('#winner-moments', {
  type   : 'loop',
  perPage: 1,
  pagination: true,
  arrows: false,
  autoplay: true,
  pauseOnHover: false,
  interval: 2500  
});

splide2.mount();

var splide3 = new Splide('#winner-cards', {
  type   : 'loop',
  perPage: 3,
  pagination: true,
  arrows: false,
  gap: 10,
  autoplay: true,
  pauseOnHover: false,
  interval: 2500,
   breakpoints: { 
    767: {
        perPage: 1,
        gap: 5,
        padding: '10%',
        pauseOnHover: false,
        autoScroll: {
            speed: 1.5,
        }
    }, 
   }
});

splide3.mount();





// Confetti Animation 
    const NUM_CONFETTI = 50; // Increased number for a denser effect
    const COLORS = [
        // More vibrant and varied colors
        [255, 105, 180], // Hot Pink
        [255, 165, 0],   // Orange
        [50, 205, 50],    // Lime Green
        [0, 191, 255],   // Deep Sky Blue
        [255, 215, 0],   // Gold
        [138, 43, 226],  // Blue Violet
        [255, 69, 0],    // Red-Orange
        [0, 255, 255],   // Cyan
    ];
    const PI_2 = 2 * Math.PI;
    const canvas = document.getElementById("world");
    console.log(canvas);
    const context = canvas.getContext("2d");
    window.w = 0;
    window.h = 0;

    let isConfettiRunning = false; // Flag to control the animation loop

    // Function to resize the canvas to fill the window
    function resizeWindow() {
        window.w = canvas.width = window.innerWidth;
        window.h = canvas.height = window.innerHeight;
    }
    window.addEventListener('resize', resizeWindow, false); // Resize on window resize
    window.onload = () => setTimeout(resizeWindow, 0); // Initial resize

    // Function to generate a random number within a range
    function range(a, b) {
        return (b - a) * Math.random() + a;
    }

    // Function to draw a filled circle on the canvas
    function drawCircle(x, y, r, style) {
        context.beginPath();
        context.arc(x, y, r, 0, PI_2, false);
        context.fillStyle = style;
        context.fill();
    }

    let xpos = 0.5; // Mouse X position (currently unused)

    // RequestAnimationFrame polyfill for smooth animation
    window.requestAnimationFrame = (() => {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            (callback => window.setTimeout(callback, 1000 / 60));
    })();

    // Confetti class to manage individual confetti particles
    class Confetti {
        constructor() {
            this.style = COLORS[~~range(0, COLORS.length)]; // Random color from the array
            this.rgb = `rgba(${this.style[0]},${this.style[1]},${this.style[2]}`;
            this.r = ~~range(3, 8); // Random radius for varied sizes
            this.r2 = 2 * this.r;
            this.replace(); // Initialize particle properties
        }

        // Function to reset or initialize particle properties
        replace() {
            this.opacity = 0; // Start with zero opacity
            this.dop = 0.03 * range(1, 4); // Random opacity change rate
            this.x = range(-this.r2, w - this.r2); // Random X position
            this.y = range(-20, h - this.r2); // Random Y position
            this.xmax = w - this.r; // Maximum X position
            this.ymax = h - this.r; // Maximum Y position
            this.vx = range(0, 2) + 8 * xpos - 5; // Horizontal velocity (currently based on unused mouse position)
            this.vy = 0.7 * this.r + range(-1, 1); // Vertical velocity
        }

        // Function to draw and update the particle
        draw() {
            this.x += this.vx; // Update X position
            this.y += this.vy; // Update Y position
            this.opacity += this.dop; // Update opacity
            if (this.opacity > 1) { // If opacity reaches 1, start fading out
                this.opacity = 1;
                this.dop *= -1;
            }
            if (this.opacity < 0 || this.y > this.ymax) { // If fully transparent or off-screen, reset
                this.replace();
            }
            if (!(0 < this.x < this.xmax)) { // Wrap around horizontally
                this.x = (this.x + this.xmax) % this.xmax;
            }
            drawCircle(~~this.x, ~~this.y, this.r, `${this.rgb},${this.opacity})`); // Draw the particle
        }
    }

    // Create an array of Confetti objects
    const confetti = Array.from({ length: NUM_CONFETTI }, () => new Confetti());

    // Animation loop function
    function step() {
        if (!isConfettiRunning) { // Check if animation should continue
            return;
        }
        requestAnimationFrame(step); // Request the next animation frame
        context.clearRect(0, 0, w, h); // Clear the canvas
        confetti.forEach(c => c.draw()); // Draw each confetti particle
    }

    // Function to start the confetti animation
    function startConfetti() {
        isConfettiRunning = true; // Set the animation flag
        resizeWindow(); // Resize the canvas
        step(); // Start the animation loop
    }


    startConfetti();

// const firstSwiper = new Swiper('.firstSwiper', {
//     reverseDirection: true,
//     slidesPerView: 3,
//       spaceBetween: 20,
//     loop: true,
//     speed: 4000, 
//     autoplay: {
//         delay: 0,
//         disableOnInteraction: false,
//     },
//     freeMode: true, 
// });